export const PORTAL_TOKEN = "efs_employee_token";

export const SIZES = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];

export const UNIFORM_PRODUCTS = [
  {
    id: "citywide",
    brand: "CityWide",
    label: "Subcontractor Apparel",
    color: "Vintage White",
    price: 18,
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elite-maintenance-1/artifacts/ovy9i476_F2255C24-8A7E-4985-9006-D4C50578DCBF.png",
    blurb: "Official CityWide subcontractor tee. Soft vintage-white cotton blend, screen-printed logo.",
  },
  {
    id: "elite",
    brand: "Elite Commercial Cleaning Service",
    label: "Elite Apparel",
    color: "Vintage White",
    price: 18,
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elite-maintenance-1/artifacts/un8kb2oc_CADF459C-504B-4482-8FB2-FC86D055CB3E.png",
    blurb: "Elite Commercial Cleaning Service crew tee. Represent the brand on every job.",
  },
];
